import React from "react";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, Button, Divider, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import RecipeFormFooter from "../components/RecipeFormFooter";
import RecipeFormStepper from "../components/RecipeFormStepper";
import TabContents from "../components/TabContents";
import { RecipeProvider } from "../store/RecipeStore";

const EditRecipePage: React.FC = () => {
  const navigate = useNavigate();

  const handleNavigateToRecipePage = () => {
    navigate("/database/recipes");
  };

  return (
    <RecipeProvider>
      <Box py={5} px={1}>
        <Box display="flex" flex={1}>
          <Button
            startIcon={<ArrowBackIcon fontSize="small" color="primary" />}
            variant="text"
            onClick={handleNavigateToRecipePage}
          >
            <Typography variant="body2" color="black" fontWeight={400}>
              Back to recipes
            </Typography>
          </Button>
        </Box>
        <Box pb={4} />
        <Box sx={{ backgroundColor: "white" }}>
          <Box
            display="flex"
            flexDirection={{ xs: "column", md: "row" }}
            justifyContent="center"
            alignItems={{ xs: "stretch", md: "center" }}
            paddingBottom={6}
          >
            <Box flex={1} padding={4}>
              <Typography variant="h5" fontWeight={800}>
                Edit Recipe
              </Typography>
            </Box>
            <Box
              flex={1}
              flexDirection="row"
              position="relative"
              top={{ xs: 0, md: -16 }}
            >
              <RecipeFormStepper />
            </Box>
            <Box flex={1} display={{ xs: "none", md: "block" }} />
          </Box>
          <Divider />
          <TabContents />
          <Divider />
          <RecipeFormFooter onCancel={handleNavigateToRecipePage} />
        </Box>
      </Box>
    </RecipeProvider>
  );
};

export default EditRecipePage;
